// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c403aa8a","227":"45362293","644":"d508eb5b","991":"e57df286"}[chunkId] + ".chunk.js";
};